<template>
  <div>
    <Bar />
    <Overlay v-if="!$screen.lg" />
  </div>
</template>

<script>
import Bar from './Bar.vue';
import Overlay from './mobile/Overlay.vue';

export default {
  name: 'PageHeader',
  components: { Overlay, Bar },
};
</script>
